const en = {
  fixed: 'Fixed',
  default: 'Default',
  save_as_custom_field: 'Save as custom field',
  kba: 'KBA',
  analyzing_: 'Analyzing...',
  download: 'Download',
  downloading_: 'Downloading...',
  view: 'View',
  autodetect_fields: 'Autodetect Fields',
  payment_link: 'Payment link',
  strikeout: 'Strikeout',
  draw_strikethrough_the_document: 'Draw strikethrough the document',
  quantity: 'Quantity',
  prefillable: 'Prefillable',
  signature_id: 'Signature ID',
  error_message: 'Error message',
  length: 'Length',
  min: 'Min',
  max: 'Max',
  font: 'Font',
  party: 'Party',
  date_signed: 'Date Signed',
  method: 'Method',
  reorder_fields: 'Reorder fields',
  verify_id: 'Verify ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Obtain qualified electronic signature (QeS) with the trusted provider. Click to learn more.',
  editable: 'Editable',
  recurrent: 'Recurrent',
  one_off: 'One-off',
  search_field: 'Search field',
  field_not_found: 'Field not found',
  clear: 'Clear',
  align: 'Align',
  resize: 'Resize',
  width: 'Width',
  height: 'Height',
  add_all_required_fields_to_continue: 'Add all required fields to continue',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Uploaded PDF contains form fields. Keep or remove them?',
  keep: 'Keep',
  left: 'Left',
  heading: 'Heading',
  validation: 'Validation',
  add_blank_page: 'Add blank page',
  right: 'Right',
  center: 'Center',
  description: 'Description',
  display_title: 'Display title',
  with_logo: 'With logo',
  unchecked: 'Unchecked',
  price: 'Price',
  type: 'Type',
  list: 'list',
  no_variables: 'No variables yet',
  no_variables_description: 'Add [[variable]] marks to your document to create dynamic content variables.',
  type_value: 'Type value',
  equal: 'Equal',
  not_equal: 'Not equal',
  greater_than: 'Greater than',
  less_than: 'Less than',
  contains: 'Contains',
  does_not_contain: 'Does not contain',
  not_empty: 'Not empty',
  empty: 'Empty',
  select_field_: 'Select field...',
  select_value_: 'Select value...',
  remove_condition: 'Remove condition',
  add_condition: 'Add condition',
  are_you_sure_: 'Are you sure?',
  sign_yourself: 'Sign Yourself',
  set_signing_date: 'Set signing date',
  signing_date: 'Signing Date',
  signing_date_and_time: 'Signing Date and Time',
  send: 'Send',
  remove: 'Remove',
  edit: 'Edit',
  settings: 'Settings',
  up: 'Up',
  down: 'Down',
  checked: 'Checked',
  current_date: 'Current date',
  save: 'Save',
  cancel: 'Cancel',
  any: 'Any',
  drawn: 'Drawn',
  drawn_or_typed: 'Drawn or Typed',
  drawn_or_upload: 'Drawn or Upload',
  upload: 'Upload',
  formula: 'Formula',
  typed: 'Typed',
  draw_field_on_the_document: 'Draw a field on the document',
  click_to_upload: 'Click to upload',
  or_drag_and_drop_files: 'or drag and drop files',
  uploading: 'Uploading',
  processing_: 'Processing...',
  add_pdf_documents_or_images: 'Add PDF documents or images',
  add_documents_or_images: 'Add documents or images',
  add_a_new_document: 'Add a new document',
  replace_existing_document: 'Replace existing document',
  clone_and_replace_documents: 'Clone and replace documents',
  required: 'Required',
  default_value: 'Default value',
  format: 'Format',
  read_only: 'Read-only',
  page: 'Page',
  draw_new_area: 'Draw new area',
  copy_to_all_pages: 'Copy to all pages',
  more: 'More',
  add_option: 'Add option',
  option: 'Option',
  options: 'Options',
  condition: 'Condition',
  make_dynamic: 'Make dynamic',
  first_party: 'First Party',
  second_party: 'Second Party',
  third_party: 'Third Party',
  fourth_party: 'Fourth Party',
  fifth_party: 'Fifth Party',
  sixth_party: 'Sixth Party',
  seventh_party: 'Seventh Party',
  eighth_party: 'Eighth Party',
  ninth_party: 'Ninth Party',
  tenth_party: 'Tenth Party',
  eleventh_party: 'Eleventh Party',
  twelfth_party: 'Twelfth Party',
  thirteenth_party: 'Thirteenth Party',
  fourteenth_party: 'Fourteenth Party',
  fifteenth_party: 'Fifteenth Party',
  sixteenth_party: 'Sixteenth Party',
  seventeenth_party: 'Seventeenth Party',
  eighteenth_party: 'Eighteenth Party',
  nineteenth_party: 'Nineteenth Party',
  twentieth_party: 'Twentieth Party',
  draw: 'Draw',
  add: 'Add',
  or_add_field_without_drawing: 'Or add field without drawing',
  text: 'Text',
  number: 'Number',
  signature: 'Signature',
  initials: 'Initials',
  date: 'Date',
  image: 'Image',
  file: 'File',
  select: 'Select',
  checkbox: 'Checkbox',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cells',
  stamp: 'Stamp',
  payment: 'Payment',
  phone: 'Phone',
  text_field: 'Text Field',
  signature_field: 'Signature Field',
  initials_field: 'Initials Field',
  date_field: 'Date Field',
  number_field: 'Number Field',
  image_field: 'Image Field',
  file_field: 'File Field',
  select_field: 'Select Field',
  checkbox_field: 'Checkbox Field',
  multiple_field: 'Multiple Select Field',
  radio_field: 'Radio Group Field',
  cells_field: 'Cells Field',
  stamp_field: 'Stamp Field',
  payment_field: 'Payment Field',
  phone_field: 'Phone Field',
  draw_a_text_field_on_the_page_with_a_mouse: 'Draw a text field on the page with a mouse',
  drag_and_drop_any_other_field_type_on_the_page: 'Drag & drop any other field type on the page',
  click_on_the_field_type_above_to_start_drawing_it: 'Click on the field type above to start drawing it',
  please_draw_fields_to_prepare_the_document: 'Please draw fields to prepare the document.',
  only_pdf_and_images_are_supported: 'Only PDF and images are supported.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Unlock SMS-verified phone number field with paid plan. Use text field for phone numbers without verification.',
  available_only_in_pro: 'Available only in Pro',
  failed_to_download_files: 'Failed to download files',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Please add fields for the {submitter_name}. Or, remove the {submitter_name} if not needed.',
  draw_field: 'Draw {field} Field',
  replace: 'Replace',
  uploading_: 'Uploading...',
  add_document: 'Add Document',
  none: 'None',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Custom',
  numbers_only: 'Numbers only',
  letters_only: 'Letters only',
  regexp_validation: 'Regexp validation',
  custom_validation: 'Custom Validation',
  length_validation: 'Length Validation',
  number_range: 'Number Range',
  enter_pdf_password: 'Enter PDF password',
  wrong_password: 'Wrong password',
  currency: 'Currency',
  save_and_preview: 'Save and Preview',
  preferences: 'Preferences',
  available_in_pro: 'Available in Pro',
  some_fields_are_missing_in_the_formula: 'Some fields are missing in the formula.',
  learn_more: 'Learn more',
  and: 'and',
  or: 'or',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Digital Signatures by Universal Cinergia',
  start_tour: 'CREATE DOCUMENT',
  or_add_from: 'Or add from',
  sync: 'Sync',
  syncing: 'Syncing...',
  copy: 'Copy',
  paste: 'Paste',
  select_fields: 'Select Fields',
  draw_fields: 'Draw Fields',
  align_left: 'Align Left',
  align_right: 'Align Right',
  align_top: 'Align Top',
  align_bottom: 'Align Bottom',
  fields_selected: '{count} Fields Selected',
  field_added: '{count} Field Added',
  fields_added: '{count} Fields Added'
}

const es = {
  fixed: 'Fijo',
  default: 'Predeterminado',
  save_as_custom_field: 'Guardar como personalizado',
  kba: 'KBA',
  autodetect_fields: 'Autodetectar campos',
  analyzing_: 'Analizando...',
  download: 'Descargar',
  downloading_: 'Descargando...',
  view: 'Vista',
  payment_link: 'Enlace de pago',
  strikeout: 'Tachar',
  draw_strikethrough_the_document: 'Dibujar una línea de tachado en el documento',
  quantity: 'Cantidad',
  prefillable: 'Rellenable',
  signature_id: 'ID de Firma',
  error_message: 'Mensaje de error',
  length: 'Longitud',
  min: 'Mín',
  max: 'Máx',
  date_signed: 'Fecha actual',
  fuente: 'Fuente',
  party: 'Parte',
  method: 'Método',
  reorder_fields: 'Reordenar campos',
  verify_id: 'Verificar ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Obtenga una firma electrónica cualificada (QeS) con el proveedor de confianza. Haga clic para obtener más información.',
  recurrent: 'Recurrente',
  one_off: 'Único',
  editable: 'Editable',
  search_field: 'Campo de búsqueda',
  field_not_found: 'Campo no encontrado',
  clear: 'Borrar',
  type: 'Tipo',
  list: 'lista',
  no_variables: 'Aún sin variables',
  no_variables_description: 'Agregue marcas [[variable]] a su documento para crear variables de contenido dinámico.',
  type_value: 'Escriba valor',
  align: 'Alinear',
  resize: 'Redimensionar',
  width: 'Ancho',
  height: 'Alto',
  add_all_required_fields_to_continue: 'Agregar todos los campos requeridos para continuar',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'El PDF cargado tiene campos. ¿Mantenerlos o eliminarlos?',
  keep: 'Mantener',
  left: 'Izquierda',
  heading: 'Encabezado',
  validation: 'Validación',
  add_blank_page: 'Agregar página en blanco',
  right: 'Derecha',
  center: 'Centro',
  with_logo: 'Con logotipo',
  description: 'Descripción',
  signing_date: 'Fecha de Firma',
  signing_date_and_time: 'Fecha y Hora de Firma',
  display_title: 'Título de visualización',
  unchecked: 'No marcado',
  price: 'Precio',
  equal: 'Igual',
  not_equal: 'No es igual',
  greater_than: 'Mayor que',
  less_than: 'Menor que',
  contains: 'Contiene',
  does_not_contain: 'No contiene',
  not_empty: 'No vacío',
  empty: 'Vacío',
  select_field_: 'Seleccionar campo...',
  select_value_: 'Seleccionar valor...',
  remove_condition: 'Eliminar condición',
  add_condition: 'Agregar condición',
  condition: 'Condición',
  make_dynamic: 'Hacer dinámico',
  formula: 'Fórmula',
  edit: 'Editar',
  settings: 'Configuración',
  up: 'Arriba',
  down: 'Abajo',
  set_signing_date: 'Establecer fecha de firma',
  are_you_sure_: '¿Estás seguro?',
  sign_yourself: 'Firma tú mismo',
  checked: 'Seleccionado',
  current_date: 'Fecha actual',
  send: 'Enviar',
  remove: 'Eliminar',
  save: 'Guardar',
  cancel: 'Cancelar',
  or_add_field_without_drawing: 'O añadir campo sin dibujar',
  draw_field_on_the_document: 'Dibujar un campo en el documento',
  click_to_upload: 'Haz clic para cargar',
  or_drag_and_drop_files: 'o arrastra y suelta archivos',
  uploading: 'Subiendo',
  processing_: 'Procesando...',
  add_pdf_documents_or_images: 'Agregar documentos PDF o imágenes',
  add_documents_or_images: 'Agregar documentos o imágenes',
  add_a_new_document: 'Agregar un nuevo documento',
  replace_existing_document: 'Reemplazar documento existente',
  clone_and_replace_documents: 'Clonar y reemplazar documentos',
  required: 'Requerido',
  default_value: 'Valor predeterminado',
  format: 'Formato',
  read_only: 'Solo lectura',
  page: 'Página',
  draw_new_area: 'Dibujar nueva área',
  copy_to_all_pages: 'Copiar a todas las páginas',
  more: 'Más',
  add_option: 'Agregar opción',
  option: 'Opción',
  options: 'Opciones',
  first_party: 'Primera Parte',
  second_party: 'Segunda Parte',
  third_party: 'Tercera Parte',
  fourth_party: 'Cuarta Parte',
  fifth_party: 'Quinta Parte',
  sixth_party: 'Sexta Parte',
  seventh_party: 'Séptima Parte',
  eighth_party: 'Octava Parte',
  ninth_party: 'Novena Parte',
  tenth_party: 'Décima Parte',
  eleventh_party: 'Undécimo Partido',
  twelfth_party: 'Duodécimo Partido',
  thirteenth_party: 'Decimotercer Partido',
  fourteenth_party: 'Catorceavo Partido',
  fifteenth_party: 'Quinceavo Partido',
  sixteenth_party: 'Dieciséisavo Partido',
  seventeenth_party: 'Diecisieteavo Partido',
  eighteenth_party: 'Dieciochoavo Partido',
  nineteenth_party: 'Decimonovena Fiesta',
  twentieth_party: 'Vigésima Fiesta',
  draw: 'Dibujar',
  add: 'Agregar',
  text: 'Texto',
  signature: 'Firma',
  initials: 'Iniciales',
  date: 'Fecha',
  number: 'Número',
  image: 'Imagen',
  file: 'Archivo',
  select: 'Seleccionar',
  checkbox: 'Casilla',
  multiple: 'Múltiple',
  radio: 'Radio',
  cells: 'Celdas',
  stamp: 'Sello',
  payment: 'Pago',
  phone: 'Teléfono',
  text_field: 'Campo de Texto',
  signature_field: 'Campo de Firma',
  initials_field: 'Campo de Iniciales',
  date_field: 'Campo de Fecha',
  number_field: 'Campo de Número',
  image_field: 'Campo de Imagen',
  file_field: 'Campo de Archivo',
  select_field: 'Campo de Selección',
  checkbox_field: 'Campo de Casilla',
  multiple_field: 'Campo Múltiple',
  radio_field: 'Campo de Grupo Radio',
  cells_field: 'Campo de Celdas',
  stamp_field: 'Campo de Sello',
  payment_field: 'Campo de Pago',
  phone_field: 'Campo de Teléfono',
  draw_a_text_field_on_the_page_with_a_mouse: 'Dibujar un campo de texto en la página con el mouse',
  drag_and_drop_any_other_field_type_on_the_page: 'Arrastra y suelta cualquier otro tipo de campo en la página',
  click_on_the_field_type_above_to_start_drawing_it: 'Haz clic en el tipo de campo de arriba para comenzar a dibujarlo',
  please_draw_fields_to_prepare_the_document: 'Por favor, dibuja los campos para preparar el documento.',
  only_pdf_and_images_are_supported: 'Solo se admiten PDF e imágenes.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Desbloquea el campo de número de teléfono verificado por SMS con un plan pago. Usa el campo de texto para números de teléfono sin verificación.',
  available_only_in_pro: 'Disponible solo en Pro',
  failed_to_download_files: 'Error al descargar los archivos',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Por favor, añade campos para {submitter_name} o elimina {submitter_name} si no es necesario.',
  draw_field: 'Dibujar campo {field}',
  replace: 'Reemplazar',
  uploading_: 'Subiendo...',
  add_document: 'Subir',
  any: 'Cualquier',
  drawn: 'Dibujado',
  drawn_or_typed: 'Dibujado o Escrito',
  drawn_or_upload: 'Dibujado o Subido',
  upload: 'Subir',
  typed: 'Escrito',
  none: 'Ninguno',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Correo electrónico',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Personalizado',
  numbers_only: 'Solo números',
  letters_only: 'Solo letras',
  regexp_validation: 'Validación de expresión regular',
  custom_validation: 'Validación Personalizada',
  length_validation: 'Validación de Longitud',
  number_range: 'Rango de Números',
  enter_pdf_password: 'Ingrese la contraseña del PDF',
  wrong_password: 'Contraseña incorrecta',
  currency: 'Moneda',
  save_and_preview: 'Guardar y previsualizar',
  preferences: 'Preferencias',
  available_in_pro: 'Disponible en Pro',
  some_fields_are_missing_in_the_formula: 'Faltan algunos campos en la fórmula.',
  learn_more: 'Aprende más',
  and: 'y',
  or: 'o',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Inicia una guía rápida para aprender a crear y enviar tu primer documento.',
  start_tour: 'Iniciar guía',
  or_add_from: 'O agregar desde',
  sync: 'Sincronizar',
  syncing: 'Sincronizando...',
  copy: 'Copiar',
  paste: 'Pegar',
  select_fields: 'Seleccionar Campos',
  draw_fields: 'Dibujar Campos',
  align_left: 'Alinear a la izquierda',
  align_right: 'Alinear a la derecha',
  align_top: 'Alinear arriba',
  align_bottom: 'Alinear abajo',
  fields_selected: '{count} Campos Seleccionados',
  field_added: '{count} Campo Añadido',
  fields_added: '{count} Campos Añadidos'
}

const it = {
  fixed: 'Fisso',
  default: 'Predefinito',
  save_as_custom_field: 'Salva come personalizzato',
  kba: 'KBA',
  autodetect_fields: 'Rileva campi',
  analyzing_: 'Analisi...',
  download: 'Scarica',
  downloading_: 'Download in corso...',
  view: 'Vista',
  payment_link: 'Link di pagamento',
  strikeout: 'Barrato',
  draw_strikethrough_the_document: 'Disegna una linea barrata sul documento',
  quantity: 'Quantità',
  prefillable: 'Precompilabile',
  signature_id: 'ID firma',
  error_message: 'Messaggio di errore',
  length: 'Lunghezza',
  min: 'Min',
  max: 'Max',
  date_signed: 'Data attuale',
  font: 'Carattere',
  party: 'Parte',
  method: 'Metodo',
  reorder_fields: 'Riordina i campi',
  verify_id: 'Verifica ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Ottieni una firma elettronica qualificata (QeS) con il fornitore di fiducia. Clicca per saperne di più.',
  ricorrente: 'Ricorrente',
  una_volta: 'Una volta',
  editable: 'Modificabile',
  search_field: 'Campo di ricerca',
  field_not_found: 'Campo non trovato',
  clear: 'Cancella',
  align: 'Allinea',
  resize: 'Ridimensiona',
  width: 'Larghezza',
  height: 'Altezza',
  add_all_required_fields_to_continue: 'Aggiungi tutti i campi obbligatori per continuare',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Il PDF caricato contiene campi del modulo. Mantenerli o rimuoverli?',
  keep: 'Mantieni',
  left: 'Sinistra',
  heading: 'Intestazione',
  validation: 'Validazione',
  add_blank_page: 'Aggiungi pagina vuota',
  right: 'Destra',
  center: 'Centro',
  description: 'Descrizione',
  display_title: 'Mostra titolo',
  with_logo: 'Con logo',
  unchecked: 'Non selezionato',
  price: 'Prezzo',
  type: 'Tipo',
  list: 'lista',
  no_variables: 'Ancora nessuna variabile',
  no_variables_description: 'Aggiungi marcatori [[variable]] al documento per creare variabili di contenuto dinamico.',
  type_value: 'Inserisci valore',
  equal: 'Uguale',
  not_equal: 'Non uguale',
  greater_than: 'Maggiore di',
  less_than: 'Minore di',
  contains: 'Contiene',
  does_not_contain: 'Non contiene',
  not_empty: 'Non vuoto',
  empty: 'Vuoto',
  select_field_: 'Seleziona campo...',
  select_value_: 'Seleziona valore...',
  remove_condition: 'Rimuovi condizione',
  add_condition: 'Aggiungi condizione',
  are_you_sure_: 'Sei sicuro?',
  sign_yourself: 'Firma te stesso',
  set_signing_date: 'Imposta data di firma',
  signing_date: 'Data di firma',
  signing_date_and_time: 'Data e ora di firma',
  send: 'Invia',
  remove: 'Rimuovi',
  edit: 'Modifica',
  settings: 'Impostazioni',
  up: 'Su',
  down: 'Giù',
  checked: 'Selezionato',
  current_date: 'Data corrente',
  save: 'Salva',
  cancel: 'Annulla',
  any: 'Qualsiasi',
  drawn: 'Disegnato',
  drawn_or_typed: 'Disegnato o Digitato',
  drawn_or_upload: 'Disegnato o Caricato',
  upload: 'Caricare',
  formula: 'Formula',
  typed: 'Digitato',
  draw_field_on_the_document: 'Disegnare un campo sul documento',
  click_to_upload: 'Clicca per caricare',
  or_drag_and_drop_files: 'o trascina e rilascia i file',
  uploading: 'Caricamento in corso',
  processing_: 'Elaborazione...',
  add_pdf_documents_or_images: 'Aggiungi documenti PDF o immagini',
  add_documents_or_images: 'Aggiungi documenti o immagini',
  add_a_new_document: 'Aggiungi un nuovo documento',
  replace_existing_document: 'Sostituisci documento esistente',
  clone_and_replace_documents: 'Clona e sostituisci documenti',
  required: 'Obbligatorio',
  default_value: 'Valore predefinito',
  format: 'Formato',
  read_only: 'Sola lettura',
  page: 'Pagina',
  draw_new_area: 'Disegna nuova area',
  copy_to_all_pages: 'Copia in tutte le pagine',
  more: 'Altro',
  add_option: 'Aggiungi opzione',
  option: 'Opzione',
  options: 'Opzioni',
  condition: 'Condizione',
  make_dynamic: 'Rendi dinamico',
  first_party: 'Prima parte',
  second_party: 'Seconda parte',
  third_party: 'Terza parte',
  fourth_party: 'Quarta parte',
  fifth_party: 'Quinta parte',
  sixth_party: 'Sesta parte',
  seventh_party: 'Settima parte',
  eighth_party: 'Ottava parte',
  ninth_party: 'Nona parte',
  tenth_party: 'Decima parte',
  eleventh_party: 'Undicesima parte',
  twelfth_party: 'Dodicesima parte',
  thirteenth_party: 'Tredicesima parte',
  fourteenth_party: 'Quattordicesima parte',
  fifteenth_party: 'Quindicesima parte',
  sixteenth_party: 'Sedicesima parte',
  seventeenth_party: 'Diciassettesima parte',
  eighteenth_party: 'Diciottesima parte',
  nineteenth_party: 'Diciannovesima parte',
  twentieth_party: 'Ventesima parte',
  draw: 'Disegna',
  add: 'Aggiungi',
  or_add_field_without_drawing: 'Oppure aggiungi campo senza disegno',
  text: 'Testo',
  number: 'Numero',
  signature: 'Firma',
  initials: 'Iniziali',
  date: 'Data',
  image: 'Immagine',
  file: 'File',
  select: 'Seleziona',
  checkbox: 'Checkbox',
  multiple: 'Multiplo',
  radio: 'Radio',
  cells: 'Celle',
  stamp: 'Timbro',
  payment: 'Pagamento',
  phone: 'Telefono',
  text_field: 'Campo di Testo',
  signature_field: 'Campo di Firma',
  initials_field: 'Campo di Iniziali',
  date_field: 'Campo Data',
  number_field: 'Campo Numero',
  image_field: 'Campo Immagine',
  file_field: 'Campo File',
  select_field: 'Campo di Selezione',
  checkbox_field: 'Campo di Checkbox',
  multiple_field: 'Campo Selezione Multipla',
  radio_field: 'Campo di Gruppo Radio',
  cells_field: 'Campo Celle',
  stamp_field: 'Campo Timbro',
  payment_field: 'Campo Pagamento',
  phone_field: 'Campo Telefono',
  draw_a_text_field_on_the_page_with_a_mouse: 'Disegna un campo di testo sulla pagina con il mouse',
  drag_and_drop_any_other_field_type_on_the_page: 'Trascina e rilascia qualsiasi altro tipo di campo sulla pagina',
  click_on_the_field_type_above_to_start_drawing_it: 'Clicca sul tipo di campo sopra per iniziare a disegnarlo',
  please_draw_fields_to_prepare_the_document: 'Per favore, disegna i campi per preparare il documento.',
  only_pdf_and_images_are_supported: 'Sono supportati solo PDF e immagini.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Sblocca il campo numero di telefono verificato tramite SMS con un piano a pagamento. Usa il campo di testo per numeri di telefono senza verifica.',
  available_only_in_pro: 'Disponibile solo in Pro',
  failed_to_download_files: 'Impossibile scaricare i file',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Aggiungi campi per {submitter_name} o rimuovi {submitter_name} se non necessario.',
  draw_field: 'Disegna il campo {field}',
  replace: 'Sostituisci',
  uploading_: 'Caricamento in corso...',
  add_document: 'Aggiungi',
  none: 'Nessuno',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: 'CAP',
  custom: 'Personalizzato',
  numbers_only: 'Solo numeri',
  letters_only: 'Solo lettere',
  regexp_validation: 'Validazione regexp',
  custom_validation: 'Validazione Personalizzata',
  length_validation: 'Validazione Lunghezza',
  number_range: 'Intervallo Numerico',
  enter_pdf_password: 'Inserisci password PDF',
  wrong_password: 'Password errata',
  currency: 'Valuta',
  save_and_preview: 'Salva e Anteprima',
  preferences: 'Preferenze',
  available_in_pro: 'Disponibile in Pro',
  some_fields_are_missing_in_the_formula: 'Alcuni campi mancano nella formula.',
  learn_more: 'Scopri di più',
  and: 'e',
  or: 'o',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Inizia un tour rapido per imparare a creare e inviare il tuo primo documento.',
  start_tour: 'Inizia il tour',
  or_add_from: 'O aggiungi da',
  sync: 'Sincronizza',
  syncing: 'Sincronizzazione...',
  copy: 'Copia',
  paste: 'Incolla',
  select_fields: 'Seleziona Campi',
  draw_fields: 'Disegna Campi',
  align_left: 'Allinea a sinistra',
  align_right: 'Allinea a destra',
  align_top: 'Allinea in alto',
  align_bottom: 'Allinea in basso',
  fields_selected: '{count} Campi Selezionati',
  field_added: '{count} Campo Aggiunto',
  fields_added: '{count} Campi Aggiunti'
}

const pt = {
  fixed: 'Fixo',
  default: 'Padrão',
  save_as_custom_field: 'Salvar como personalizado',
  kba: 'KBA',
  autodetect_fields: 'Detectar campos',
  analyzing_: 'Analisando...',
  download: 'Baixar',
  downloading_: 'Baixando...',
  view: 'Visualizar',
  payment_link: 'Link de pagamento',
  strikeout: 'Tachado',
  draw_strikethrough_the_document: 'Desenhe uma linha de tachado no documento',
  quantity: 'Quantidade',
  prefillable: 'Pré-preenchível',
  signature_id: 'ID da Assinatura',
  error_message: 'Mensagem de erro',
  length: 'Comprimento',
  min: 'Mín',
  max: 'Máx',
  date_signed: 'Data atual',
  fonte: 'Fonte',
  party: 'Parte',
  method: 'Método',
  reorder_fields: 'Reorganizar campos',
  verify_id: 'Verificar ID',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Obtenha a assinatura eletrônica qualificada (QeS) com o provedor confiável. Clique para saber mais.',
  recurrent: 'Recurrente',
  one_off: 'Único',
  editable: 'Editável',
  search_field: 'Campo de busca',
  field_not_found: 'Campo não encontrado',
  clear: 'Limpar',
  type: 'Tipo',
  list: 'lista',
  no_variables: 'Ainda sem variáveis',
  no_variables_description: 'Adicione marcações [[variable]] ao documento para criar variáveis de conteúdo dinâmico.',
  type_value: 'Digite valor',
  add_all_required_fields_to_continue: 'Adicione todos os campos obrigatórios para continuar',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'O PDF carregado contém campos. Manter ou removê-los?',
  keep: 'Manter',
  align: 'Alinhar',
  resize: 'Redimensionar',
  width: 'Largura',
  height: 'Altura',
  left: 'Esquerda',
  heading: 'Cabeçalho',
  validation: 'Validação',
  add_blank_page: 'Adicionar página em branco',
  right: 'Direita',
  center: 'Centro',
  with_logo: 'Com logotipo',
  description: 'Descrição',
  display_title: 'Título de exibição',
  signing_date: 'Data da Assinatura',
  signing_date_and_time: 'Data e Hora da Assinatura',
  unchecked: 'Não marcado',
  price: 'Preço',
  equal: 'Igual',
  not_equal: 'Não é igual',
  greater_than: 'Maior que',
  less_than: 'Menor que',
  contains: 'Contém',
  does_not_contain: 'Não contém',
  not_empty: 'Não vazio',
  empty: 'Vazio',
  add_condition: 'Adicionar condição',
  select_field_: 'Selecionar campo...',
  select_value_: 'Selecionar valor...',
  remove_condition: 'Remover condição',
  condition: 'Condição',
  make_dynamic: 'Tornar dinâmico',
  formula: 'Fórmula',
  edit: 'Editar',
  settings: 'Configurações',
  up: 'Para cima',
  down: 'Para baixo',
  set_signing_date: 'Definir data de assinatura',
  are_you_sure_: 'Tem certeza?',
  sign_yourself: 'Assine você mesmo',
  checked: 'Marcado',
  current_date: 'Data atual',
  send: 'Enviar',
  remove: 'Remover',
  save: 'Salvar',
  cancel: 'Cancelar',
  or_add_field_without_drawing: 'Ou adicione campo sem desenhar',
  draw_field_on_the_document: 'Desenhar um campo no documento',
  click_to_upload: 'Clique para enviar',
  or_drag_and_drop_files: 'ou arraste e solte arquivos',
  uploading: 'Carregando',
  processing_: 'Processando...',
  add_pdf_documents_or_images: 'Adicionar documentos PDF ou imagens',
  add_documents_or_images: 'Adicionar documentos ou imagens',
  add_a_new_document: 'Ajouter un nouveau document',
  replace_existing_document: 'Substituir documento existente',
  clone_and_replace_documents: 'Clonar e substituir documentos',
  required: 'Obrigatório',
  default_value: 'Valor padrão',
  format: 'Formato',
  read_only: 'Somente leitura',
  page: 'Página',
  draw_new_area: 'Desenhar nova área',
  copy_to_all_pages: 'Copiar para todas as páginas',
  more: 'Mais',
  add_option: 'Adicionar opção',
  option: 'Opção',
  options: 'Opções',
  first_party: 'Primeira Parte',
  second_party: 'Segunda Parte',
  third_party: 'Terceira Parte',
  fourth_party: 'Quarta Parte',
  fifth_party: 'Quinta Parte',
  sixth_party: 'Sexta Parte',
  seventh_party: 'Sétima Parte',
  eighth_party: 'Oitava Parte',
  ninth_party: 'Nona Parte',
  tenth_party: 'Décima Parte',
  eleventh_party: 'Décima Primeira Parte',
  twelfth_party: 'Décima Segunda Parte',
  thirteenth_party: 'Décima Terceira Parte',
  fourteenth_party: 'Décima Quarta Parte',
  fifteenth_party: 'Décima Quinta Parte',
  sixteenth_party: 'Décima Sexta Parte',
  seventeenth_party: 'Décima Sétima Parte',
  eighteenth_party: 'Décima Oitava Parte',
  nineteenth_party: 'Décima Nona Parte',
  twentieth_party: 'Vigésima Parte',
  draw: 'Desenhar',
  add: 'Adicionar',
  text: 'Texto',
  signature: 'Assinatura',
  initials: 'Rúbrica',
  date: 'Data',
  number: 'Número',
  image: 'Imagem',
  file: 'Arquivo',
  select: 'Selecionar',
  checkbox: 'Caixa',
  multiple: 'Múltiplo',
  radio: 'Rádio',
  cells: 'Células',
  stamp: 'Carimbo',
  payment: 'Pagamento',
  phone: 'Telefone',
  text_field: 'Campo de Texto',
  signature_field: 'Campo de Assinatura',
  initials_field: 'Campo de Rúbrica',
  date_field: 'Campo de Data',
  number_field: 'Campo de Número',
  image_field: 'Campo de Imagem',
  file_field: 'Campo de Arquivo',
  select_field: 'Campo de Seleção',
  checkbox_field: 'Campo de Caixa',
  multiple_field: 'Campo de Opção Múltipla',
  radio_field: 'Campo de Grupo Rádio',
  cells_field: 'Campo de Células',
  stamp_field: 'Campo de Carimbo',
  payment_field: 'Campo de Pagamento',
  phone_field: 'Campo de Telefone',
  draw_a_text_field_on_the_page_with_a_mouse: 'Desenhar um campo de texto na página com o mouse',
  drag_and_drop_any_other_field_type_on_the_page: 'Arraste e solte qualquer outro tipo de campo na página',
  click_on_the_field_type_above_to_start_drawing_it: 'Clique no tipo de campo acima para começar a desenhá-lo',
  please_draw_fields_to_prepare_the_document: 'Por favor, desenhe os campos para preparar o documento.',
  only_pdf_and_images_are_supported: 'Apenas PDFs e imagens são suportados.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Desbloqueie o campo de número de telefone verificado por SMS com um plano pago. Use o campo de texto para números de telefone sem verificação.',
  available_only_in_pro: 'Disponível apenas no Pro',
  failed_to_download_files: 'Falha ao baixar arquivos',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Adicione campos para {submitter_name} ou remova {submitter_name} se não for necessário.',
  draw_field: 'Desenhar campo {field}',
  replace: 'Substituir',
  uploading_: 'Carregando...',
  add_document: 'Enviar',
  any: 'Qualquer',
  drawn: 'Desenhado',
  drawn_or_typed: 'Desenhado ou Digitado',
  drawn_or_upload: 'Desenhado ou Enviado',
  upload: 'Carregar',
  typed: 'Digitado',
  none: 'Nenhum',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'Email',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Personalizado',
  numbers_only: 'Somente números',
  letters_only: 'Somente letras',
  regexp_validation: 'Validação de expressão regular',
  custom_validation: 'Validação Personalizada',
  length_validation: 'Validação de Comprimento',
  number_range: 'Intervalo de Números',
  enter_pdf_password: 'Digite a senha do PDF',
  wrong_password: 'Senha incorreta',
  currency: 'Moeda',
  save_and_preview: 'Salvar e Pré-visualizar',
  preferences: 'Preferências',
  available_in_pro: 'Disponível no Pro',
  some_fields_are_missing_in_the_formula: 'Faltam alguns campos na fórmula.',
  learn_more: 'Saiba mais',
  and: 'e',
  or: 'ou',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Comece um tour rápido para aprender a criar e enviar seu primeiro documento.',
  start_tour: 'Iniciar tour',
  or_add_from: 'Ou adicionar de',
  sync: 'Sincronizar',
  syncing: 'Sincronizando...',
  copy: 'Copiar',
  paste: 'Colar',
  select_fields: 'Selecionar Campos',
  draw_fields: 'Desenhar Campos',
  align_left: 'Alinhar à esquerda',
  align_right: 'Alinhar à direita',
  align_top: 'Alinhar ao topo',
  align_bottom: 'Alinhar à parte inferior',
  fields_selected: '{count} Campos Selecionados',
  field_added: '{count} Campo Adicionado',
  fields_added: '{count} Campos Adicionados'
}

const fr = {
  fixed: 'Fixe',
  default: 'Par défaut',
  save_as_custom_field: 'Enregistrer comme personnalisé',
  kba: 'KBA',
  autodetect_fields: 'Détecter les champs',
  analyzing_: 'Analyse...',
  download: 'Télécharger',
  downloading_: 'Téléchargement...',
  view: 'Voir',
  payment_link: 'Lien de paiement',
  strikeout: 'Rature',
  draw_strikethrough_the_document: 'Tracer une rature sur le document',
  quantity: 'Quantité',
  prefillable: 'Préremplissable',
  signature_id: 'Identifiant de signature',
  error_message: "Message d'erreur",
  length: 'Longueur',
  min: 'Min',
  max: 'Max',
  font: 'Police',
  party: 'Partie',
  date_signed: 'Date de signature',
  method: 'Méthode',
  reorder_fields: 'Réorganiser les champs',
  verify_id: "Vérifier l'ID",
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Obtenez une signature électronique qualifiée (QeS) auprès du fournisseur de confiance. Cliquez pour en savoir plus.',
  editable: 'Modifiable',
  recurrent: 'Récurrent',
  one_off: 'Ponctuel',
  search_field: 'Champ de recherche',
  field_not_found: 'Champ introuvable',
  clear: 'Effacer',
  align: 'Aligner',
  resize: 'Redimensionner',
  width: 'Largeur',
  height: 'Hauteur',
  add_all_required_fields_to_continue: 'Ajoutez tous les champs obligatoires pour continuer',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Le PDF téléversé contient des champs de formulaire. Les conserver ou les supprimer ?',
  keep: 'Conserver',
  left: 'Gauche',
  heading: 'Titre',
  validation: 'Validation',
  add_blank_page: 'Ajouter une page blanche',
  right: 'Droite',
  center: 'Centre',
  description: 'Description',
  display_title: 'Afficher le titre',
  with_logo: 'Avec logo',
  unchecked: 'Décoché',
  price: 'Prix',
  type: 'Type',
  list: 'liste',
  no_variables: 'Pas encore de variables',
  no_variables_description: 'Ajoutez des balises [[variable]] à votre document pour créer des variables de contenu dynamique.',
  type_value: 'Saisir une valeur',
  equal: 'Égal',
  not_equal: 'Différent',
  greater_than: 'Supérieur à',
  less_than: 'Inférieur à',
  contains: 'Contient',
  does_not_contain: 'Ne contient pas',
  not_empty: 'Non vide',
  empty: 'Vide',
  select_field_: 'Sélectionner un champ...',
  select_value_: 'Sélectionner une valeur...',
  remove_condition: 'Supprimer la condition',
  add_condition: 'Ajouter une condition',
  are_you_sure_: 'Êtes-vous sûr ?',
  sign_yourself: 'Signer vous-même',
  set_signing_date: 'Définir la date de signature',
  signing_date: 'Date de signature',
  signing_date_and_time: 'Date et heure de signature',
  send: 'Envoyer',
  remove: 'Supprimer',
  edit: 'Modifier',
  settings: 'Paramètres',
  up: 'Haut',
  down: 'Bas',
  checked: 'Coché',
  current_date: 'Date du jour',
  save: 'Enregistrer',
  cancel: 'Annuler',
  any: "N'importe lequel",
  drawn: 'Dessiné',
  drawn_or_typed: 'Dessiné ou tapé',
  drawn_or_upload: 'Dessiné ou téléversé',
  upload: 'Téléverser',
  formula: 'Formule',
  typed: 'Tapé',
  draw_field_on_the_document: 'Dessinez un champ sur le document',
  click_to_upload: 'Cliquez pour téléverser',
  or_drag_and_drop_files: 'ou faites glisser-déposer des fichiers',
  uploading: 'Téléversement en cours',
  processing_: 'Traitement...',
  add_pdf_documents_or_images: 'Ajouter des documents PDF ou des images',
  add_documents_or_images: 'Ajouter des documents ou des images',
  add_a_new_document: 'Ajouter un nouveau document',
  replace_existing_document: 'Remplacer le document existant',
  clone_and_replace_documents: 'Cloner et remplacer des documents',
  required: 'Obligatoire',
  default_value: 'Valeur par défaut',
  format: 'Format',
  read_only: 'Lecture seule',
  page: 'Page',
  draw_new_area: 'Dessiner une zone',
  copy_to_all_pages: 'Copier sur toutes les pages',
  more: 'Plus',
  add_option: 'Ajouter une option',
  option: 'Option',
  options: 'Options',
  condition: 'Condition',
  make_dynamic: 'Rendre dynamique',
  first_party: 'Première partie',
  second_party: 'Deuxième partie',
  third_party: 'Troisième partie',
  fourth_party: 'Quatrième partie',
  fifth_party: 'Cinquième partie',
  sixth_party: 'Sixième partie',
  seventh_party: 'Septième partie',
  eighth_party: 'Huitième partie',
  ninth_party: 'Neuvième partie',
  tenth_party: 'Dixième partie',
  eleventh_party: 'Onzième partie',
  twelfth_party: 'Douzième partie',
  thirteenth_party: 'Treizième partie',
  fourteenth_party: 'Quatorzième partie',
  fifteenth_party: 'Quinzième partie',
  sixteenth_party: 'Seizième partie',
  seventeenth_party: 'Dix-septième partie',
  eighteenth_party: 'Dix-huitième partie',
  nineteenth_party: 'Dix-neuvième partie',
  twentieth_party: 'Vingtième partie',
  draw: 'Dessiner',
  add: 'Ajouter',
  or_add_field_without_drawing: 'Ou ajouter un champ sans le dessiner',
  text: 'Texte',
  number: 'Nombre',
  signature: 'Signature',
  initials: 'Initiales',
  date: 'Date',
  image: 'Image',
  file: 'Fichier',
  select: 'Sélection',
  checkbox: 'Coche',
  multiple: 'Multiple',
  radio: 'Radio',
  cells: 'Cellules',
  stamp: 'Tampon',
  payment: 'Paiement',
  phone: 'Téléphone',
  text_field: 'Champ de texte',
  signature_field: 'Champ de signature',
  initials_field: "Champ d'initiales",
  date_field: 'Champ de date',
  number_field: 'Champ de numéro',
  image_field: "Champ d'image",
  file_field: 'Champ de fichier',
  select_field: 'Champ de choix',
  checkbox_field: 'Champ de coche',
  multiple_field: 'Champ de choix multiple',
  radio_field: 'Champ de groupe radio',
  cells_field: 'Champ de cellules',
  stamp_field: 'Champ de tampon',
  payment_field: 'Champ de paiement',
  phone_field: 'Champ de téléphone',
  draw_a_text_field_on_the_page_with_a_mouse: 'Dessinez un champ de texte sur la page avec la souris',
  drag_and_drop_any_other_field_type_on_the_page: 'Glissez-déposez tout autre type de champ sur la page',
  click_on_the_field_type_above_to_start_drawing_it: 'Cliquez sur le type de champ ci-dessus pour commencer à le dessiner',
  please_draw_fields_to_prepare_the_document: 'Veuillez dessiner des champs pour préparer le document.',
  only_pdf_and_images_are_supported: 'Seuls les PDF et les images sont pris en charge.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Débloquez le champ de numéro de téléphone vérifié par SMS avec un forfait payant. Utilisez un champ texte pour les numéros sans vérification.',
  available_only_in_pro: 'Disponible uniquement dans la version Pro',
  failed_to_download_files: 'Impossible de télécharger les fichiers',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: "Veuillez ajouter des champs pour {submitter_name}. Ou supprimez {submitter_name} si ce n'est pas nécessaire.",
  draw_field: 'Dessiner le champ {field}',
  replace: 'Remplacer',
  uploading_: 'Téléversement...',
  add_document: 'Téléverser',
  none: 'Aucun',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'E-mail',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Personnalisé',
  numbers_only: 'Chiffres uniquement',
  letters_only: 'Lettres uniquement',
  regexp_validation: 'Validation par expression régulière',
  custom_validation: 'Validation Personnalisée',
  length_validation: 'Validation de Longueur',
  number_range: 'Plage de Nombres',
  enter_pdf_password: 'Saisir le mot de passe du PDF',
  wrong_password: 'Mot de passe incorrect',
  currency: 'Devise',
  save_and_preview: 'Enregistrer et prévisualiser',
  preferences: 'Préférences',
  available_in_pro: 'Disponible dans la version Pro',
  some_fields_are_missing_in_the_formula: 'Certains champs manquent dans la formule.',
  learn_more: 'En savoir plus',
  and: 'et',
  or: 'ou',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Commencez une visite rapide pour apprendre à créer et à envoyer votre premier document',
  start_tour: 'Démarrer',
  or_add_from: 'Ou ajouter depuis',
  sync: 'Synchroniser',
  syncing: 'Synchronisation...',
  copy: 'Copier',
  paste: 'Coller',
  select_fields: 'Sélectionner Champs',
  draw_fields: 'Dessiner Champs',
  align_left: 'Aligner à gauche',
  align_right: 'Aligner à droite',
  align_top: 'Aligner en haut',
  align_bottom: 'Aligner en bas',
  fields_selected: '{count} Champs Sélectionnés',
  field_added: '{count} Champ Ajouté',
  fields_added: '{count} Champs Ajoutés'
}

const de = {
  fixed: 'Fest',
  default: 'Standard',
  save_as_custom_field: 'Als benutzerdefiniert speichern',
  kba: 'KBA',
  autodetect_fields: 'Felder erkennen',
  analyzing_: 'Analysiere...',
  download: 'Download',
  downloading_: 'Download...',
  view: 'Anzeigen',
  payment_link: 'Zahlungslink',
  strikeout: 'Durchstreichen',
  draw_strikethrough_the_document: 'Durchstreichung im Dokument zeichnen',
  quantity: 'Menge',
  prefillable: 'Vorausfüllbar',
  signature_id: 'Signatur-ID',
  error_message: 'Fehlermeldung',
  length: 'Länge',
  min: 'Min.',
  max: 'Max.',
  font: 'Schriftart',
  party: 'Partei',
  date_signed: 'Unterzeichnungsdatum',
  method: 'Methode',
  reorder_fields: 'Felder neu anordnen',
  verify_id: 'ID überprüfen',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Qualifizierte elektronische Signatur (QES) beim vertrauenswürdigen Anbieter einholen. Klicken Sie, um mehr zu erfahren.',
  editable: 'Bearbeitbar',
  recurrent: 'Wiederkehrend',
  one_off: 'Einmalig',
  search_field: 'Suchfeld',
  field_not_found: 'Feld nicht gefunden',
  clear: 'Leeren',
  align: 'Ausrichten',
  resize: 'Größe ändern',
  width: 'Breite',
  height: 'Höhe',
  add_all_required_fields_to_continue: 'Fügen Sie alle erforderlichen Felder hinzu, um fortzufahren',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Das hochgeladene PDF enthält Formularfelder. Beibehalten oder entfernen?',
  keep: 'Beibehalten',
  left: 'Links',
  heading: 'Überschrift',
  validation: 'Validierung',
  add_blank_page: 'Leere Seite hinzufügen',
  right: 'Rechts',
  center: 'Zentriert',
  description: 'Beschreibung',
  display_title: 'Anzeigetitel',
  with_logo: 'Mit Logo',
  unchecked: 'Nicht markiert',
  price: 'Preis',
  type: 'Typ',
  list: 'Liste',
  no_variables: 'Noch keine Variablen',
  no_variables_description: 'Fügen Sie [[variable]]-Markierungen zu Ihrem Dokument hinzu, um dynamische Inhaltsvariablen zu erstellen.',
  type_value: 'Wert eingeben',
  equal: 'Gleich',
  not_equal: 'Ungleich',
  greater_than: 'Größer als',
  less_than: 'Kleiner als',
  contains: 'Enthält',
  does_not_contain: 'Enthält nicht',
  not_empty: 'Nicht leer',
  empty: 'Leer',
  select_field_: 'Feld auswählen...',
  select_value_: 'Wert auswählen...',
  remove_condition: 'Bedingung entfernen',
  add_condition: 'Bedingung hinzufügen',
  are_you_sure_: 'Sind Sie sicher?',
  sign_yourself: 'Selbst unterschreiben',
  set_signing_date: 'Unterzeichnungsdatum festlegen',
  signing_date: 'Unterzeichnungsdatum',
  signing_date_and_time: 'Unterzeichnungsdatum und -uhrzeit',
  send: 'Senden',
  remove: 'Entfernen',
  edit: 'Bearbeiten',
  settings: 'Einstellungen',
  up: 'Nach oben',
  down: 'Nach unten',
  checked: 'Markiert',
  current_date: 'Aktuelles Datum',
  save: 'Speichern',
  cancel: 'Abbrechen',
  any: 'Beliebig',
  drawn: 'Gezeichnet',
  drawn_or_typed: 'Gezeichnet oder getippt',
  drawn_or_upload: 'Gezeichnet oder hochgeladen',
  upload: 'Hochladen',
  formula: 'Formel',
  typed: 'Getippt',
  draw_field_on_the_document: 'Ein Feld im Dokument zeichnen',
  click_to_upload: 'Zum Hochladen klicken',
  or_drag_and_drop_files: 'oder Dateien per Drag & Drop ablegen',
  uploading: 'Hochladen...',
  processing_: 'Verarbeiten...',
  add_pdf_documents_or_images: 'PDF-Dokumente oder Bilder hinzufügen',
  add_documents_or_images: 'Dokumente oder Bilder hinzufügen',
  add_a_new_document: 'Neues Dokument hinzufügen',
  replace_existing_document: 'Vorhandenes Dokument ersetzen',
  clone_and_replace_documents: 'Dokumente klonen und ersetzen',
  required: 'Erforderlich',
  default_value: 'Standardwert',
  format: 'Format',
  read_only: 'Nur lesen',
  page: 'Seite',
  draw_new_area: 'Bereich zeichnen',
  copy_to_all_pages: 'Auf alle Seiten kopieren',
  more: 'Mehr',
  add_option: 'Option hinzufügen',
  option: 'Option',
  options: 'Optionen',
  condition: 'Bedingung',
  make_dynamic: 'Dynamisch machen',
  first_party: 'Erste Partei',
  second_party: 'Zweite Partei',
  third_party: 'Dritte Partei',
  fourth_party: 'Vierte Partei',
  fifth_party: 'Fünfte Partei',
  sixth_party: 'Sechste Partei',
  seventh_party: 'Siebte Partei',
  eighth_party: 'Achte Partei',
  ninth_party: 'Neunte Partei',
  tenth_party: 'Zehnte Partei',
  eleventh_party: 'Elfte Partei',
  twelfth_party: 'Zwölfte Partei',
  thirteenth_party: 'Dreizehnte Partei',
  fourteenth_party: 'Vierzehnte Partei',
  fifteenth_party: 'Fünfzehnte Partei',
  sixteenth_party: 'Sechzehnte Partei',
  seventeenth_party: 'Siebzehnte Partei',
  eighteenth_party: 'Achtzehnte Partei',
  nineteenth_party: 'Neunzehnte Partei',
  twentieth_party: 'Zwanzigste Partei',
  draw: 'Zeichnen',
  add: 'Hinzufügen',
  or_add_field_without_drawing: 'Oder Feld ohne Zeichnen hinzufügen',
  text: 'Text',
  number: 'Zahl',
  signature: 'Unterschrift',
  initials: 'Initialen',
  date: 'Datum',
  image: 'Bild',
  file: 'Datei',
  select: 'Auswahl',
  checkbox: 'Checkbox',
  multiple: 'Mehrfach',
  radio: 'Radio',
  cells: 'Zellen',
  stamp: 'Stempel',
  payment: 'Zahlung',
  phone: 'Telefon',
  text_field: 'Textfeld',
  signature_field: 'Unterschriftsfeld',
  initials_field: 'Initialenfeld',
  date_field: 'Datumsfeld',
  number_field: 'Zahlenfeld',
  image_field: 'Bildfeld',
  file_field: 'Dateifeld',
  select_field: 'Auswahlfeld',
  checkbox_field: 'Checkboxfeld',
  multiple_field: 'Mehrfachauswahlfeld',
  radio_field: 'Radiogruppe',
  cells_field: 'Zellenfeld',
  stamp_field: 'Stempelfeld',
  payment_field: 'Zahlungsfeld',
  phone_field: 'Telefonfeld',
  draw_a_text_field_on_the_page_with_a_mouse: 'Ein Textfeld mit der Maus auf der Seite zeichnen',
  drag_and_drop_any_other_field_type_on_the_page: 'Jeden anderen Feldtyp auf die Seite ziehen und ablegen',
  click_on_the_field_type_above_to_start_drawing_it: 'Klicken Sie oben auf den Feldtyp, um mit dem Zeichnen zu beginnen',
  please_draw_fields_to_prepare_the_document: 'Bitte zeichnen Sie Felder, um das Dokument vorzubereiten.',
  only_pdf_and_images_are_supported: 'Nur PDF und Bilder werden unterstützt.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'SMS-verifiziertes Telefonnummernfeld mit kostenpflichtigem Plan freischalten. Verwenden Sie für Telefonnummern ohne Verifizierung das Textfeld.',
  available_only_in_pro: 'Nur in Pro verfügbar',
  failed_to_download_files: 'Dateien konnten nicht heruntergeladen werden',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Bitte fügen Sie Felder für {submitter_name} hinzu oder entfernen Sie {submitter_name}, falls nicht benötigt.',
  draw_field: '{field}-Feld zeichnen',
  replace: 'Ersetzen',
  uploading_: 'Hochladen...',
  add_document: 'Hochladen',
  none: 'Keine',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'E-Mail',
  url: 'URL',
  zip: 'ZIP',
  custom: 'Benutzerdefiniert',
  numbers_only: 'Nur Zahlen',
  letters_only: 'Nur Buchstaben',
  regexp_validation: 'RegExp-Validierung',
  custom_validation: 'Benutzerdefinierte Validierung',
  length_validation: 'Längenvalidierung',
  number_range: 'Zahlenbereich',
  enter_pdf_password: 'PDF-Passwort eingeben',
  wrong_password: 'Falsches Passwort',
  currency: 'Währung',
  save_and_preview: 'Speichern und Vorschau',
  preferences: 'Voreinstellungen',
  available_in_pro: 'In Pro verfügbar',
  some_fields_are_missing_in_the_formula: 'Einige Felder fehlen in der Formel.',
  learn_more: 'Mehr erfahren',
  and: 'und',
  or: 'oder',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Starten Sie eine Kurztour, um zu lernen, wie Sie Ihr erstes Dokument erstellen und versenden.',
  start_tour: 'Tour starten',
  or_add_from: 'Oder hinzufügen aus',
  sync: 'Synchronisieren',
  syncing: 'Synchronisiere...',
  copy: 'Kopieren',
  paste: 'Einfügen',
  select_fields: 'Felder Auswählen',
  draw_fields: 'Felder Zeichnen',
  align_left: 'Links ausrichten',
  align_right: 'Rechts ausrichten',
  align_top: 'Oben ausrichten',
  align_bottom: 'Unten ausrichten',
  fields_selected: '{count} Felder Ausgewählt',
  field_added: '{count} Feld Hinzugefügt',
  fields_added: '{count} Felder Hinzugefügt'
}

const nl = {
  fixed: 'Vast',
  default: 'Standaard',
  save_as_custom_field: 'Opslaan als aangepast',
  kba: 'KBA',
  autodetect_fields: 'Velden detecteren',
  analyzing_: 'Analyseren...',
  download: 'Downloaden',
  downloading_: 'Downloaden...',
  view: 'Bekijken',
  payment_link: 'Betaallink',
  strikeout: 'Doorhalen',
  draw_strikethrough_the_document: 'Teken doorhaling in het document',
  quantity: 'Aantal',
  prefillable: 'Voorinvulbaar',
  signature_id: 'Handtekening-ID',
  error_message: 'Foutmelding',
  length: 'Lengte',
  min: 'Min',
  max: 'Max',
  font: 'Lettertype',
  party: 'Partij',
  date_signed: 'Datum ondertekend',
  method: 'Methode',
  reorder_fields: 'Velden herschikken',
  verify_id: 'ID verifiëren',
  obtain_qualified_electronic_signature_with_the_trusted_provider_click_to_learn_more: 'Verkrijg een gekwalificeerde elektronische handtekening (QeS) via de vertrouwde provider. Klik voor meer informatie.',
  editable: 'Bewerkbaar',
  recurrent: 'Terugkerend',
  one_off: 'Eenmalig',
  search_field: 'Zoekveld',
  field_not_found: 'Veld niet gevonden',
  clear: 'Wissen',
  align: 'Uitlijnen',
  resize: 'Formaat wijzigen',
  width: 'Breedte',
  height: 'Hoogte',
  add_all_required_fields_to_continue: 'Voeg alle vereiste velden toe om door te gaan',
  uploaded_pdf_contains_form_fields_keep_or_remove_them: 'Geüploade PDF bevat formuliervelden. Behouden of verwijderen?',
  keep: 'Behouden',
  left: 'Links',
  heading: 'Koptekst',
  validation: 'Validatie',
  add_blank_page: 'Lege pagina toevoegen',
  right: 'Rechts',
  center: 'Centreren',
  description: 'Beschrijving',
  display_title: 'Titel weergeven',
  with_logo: 'Met logo',
  unchecked: 'Niet aangevinkt',
  price: 'Prijs',
  type: 'Type',
  list: 'lijst',
  no_variables: 'Nog geen variabelen',
  no_variables_description: 'Voeg [[variable]]-markeringen toe aan uw document om dynamische inhoudsvariabelen te maken.',
  type_value: 'Typ waarde',
  equal: 'Gelijk aan',
  not_equal: 'Niet gelijk aan',
  greater_than: 'Groter dan',
  less_than: 'Kleiner dan',
  contains: 'Bevat',
  does_not_contain: 'Bevat niet',
  not_empty: 'Niet leeg',
  empty: 'Leeg',
  select_field_: 'Veld selecteren...',
  select_value_: 'Waarde selecteren...',
  remove_condition: 'Voorwaarde verwijderen',
  add_condition: 'Voorwaarde toevoegen',
  are_you_sure_: 'Weet u het zeker?',
  sign_yourself: 'Zelf ondertekenen',
  set_signing_date: 'Ondertekeningsdatum instellen',
  signing_date: 'Ondertekeningsdatum',
  signing_date_and_time: 'Ondertekeningsdatum en -tijd',
  send: 'Verzenden',
  remove: 'Verwijderen',
  edit: 'Bewerken',
  settings: 'Instellingen',
  up: 'Omhoog',
  down: 'Omlaag',
  checked: 'Aangevinkt',
  current_date: 'Huidige datum',
  save: 'Opslaan',
  cancel: 'Annuleren',
  any: 'Elke',
  drawn: 'Getekend',
  drawn_or_typed: 'Getekend of getypt',
  drawn_or_upload: 'Getekend of uploaden',
  upload: 'Uploaden',
  formula: 'Formule',
  typed: 'Getypt',
  draw_field_on_the_document: 'Teken een veld op het document',
  click_to_upload: 'Klik om te uploaden',
  or_drag_and_drop_files: 'of sleep bestanden hierheen',
  uploading: 'Uploaden',
  processing_: 'Bezig met verwerken...',
  add_pdf_documents_or_images: 'PDF-documenten of afbeeldingen toevoegen',
  add_documents_or_images: 'Documenten of afbeeldingen toevoegen',
  add_a_new_document: 'Nieuw document toevoegen',
  replace_existing_document: 'Bestaand document vervangen',
  clone_and_replace_documents: 'Documenten klonen en vervangen',
  required: 'Vereist',
  default_value: 'Standaardwaarde',
  format: 'Formaat',
  read_only: 'Alleen-lezen',
  page: 'Pagina',
  draw_new_area: 'Nieuw gebied tekenen',
  copy_to_all_pages: 'Kopieer naar alle pag.',
  more: 'Meer',
  add_option: 'Optie toevoegen',
  option: 'Optie',
  options: 'Opties',
  condition: 'Voorwaarde',
  make_dynamic: 'Dynamisch maken',
  first_party: 'Eerste partij',
  second_party: 'Tweede partij',
  third_party: 'Derde partij',
  fourth_party: 'Vierde partij',
  fifth_party: 'Vijfde partij',
  sixth_party: 'Zesde partij',
  seventh_party: 'Zevende partij',
  eighth_party: 'Achtste partij',
  ninth_party: 'Negende partij',
  tenth_party: 'Tiende partij',
  eleventh_party: 'Elfde partij',
  twelfth_party: 'Twaalfde partij',
  thirteenth_party: 'Dertiende partij',
  fourteenth_party: 'Veertiende partij',
  fifteenth_party: 'Vijftiende partij',
  sixteenth_party: 'Zestiende partij',
  seventeenth_party: 'Zeventiende partij',
  eighteenth_party: 'Achttiende partij',
  nineteenth_party: 'Negentiende partij',
  twentieth_party: 'Twintigste partij',
  draw: 'Tekenen',
  add: 'Toevoegen',
  or_add_field_without_drawing: 'Of voeg een veld toe zonder te tekenen',
  text: 'Tekst',
  number: 'Getal',
  signature: 'Signatuur',
  initials: 'Initialen',
  date: 'Datum',
  image: 'Afbeelding',
  file: 'Bestand',
  select: 'Selecteren',
  checkbox: 'Checkbox',
  multiple: 'Meerdere',
  radio: 'Radio',
  cells: 'Cellen',
  stamp: 'Stempel',
  payment: 'Betaling',
  phone: 'Telefoon',
  text_field: 'Tekstveld',
  signature_field: 'Signatuurveld',
  initials_field: 'Initialenveld',
  date_field: 'Datumveld',
  number_field: 'Getalveld',
  image_field: 'Afbeeldingsveld',
  file_field: 'Bestandsveld',
  select_field: 'Selectieveld',
  checkbox_field: 'Aankruisvakje',
  multiple_field: 'Meerkeuzeveld',
  radio_field: 'Radiogroepveld',
  cells_field: 'Cellenveld',
  stamp_field: 'Stempelveld',
  payment_field: 'Betalingsveld',
  phone_field: 'Telefoonveld',
  draw_a_text_field_on_the_page_with_a_mouse: 'Teken met de muis een tekstveld op de pagina',
  drag_and_drop_any_other_field_type_on_the_page: 'Sleep elk ander veldtype naar de pagina',
  click_on_the_field_type_above_to_start_drawing_it: 'Klik op het bovenstaande veldtype om te beginnen met tekenen',
  please_draw_fields_to_prepare_the_document: 'Teken velden om het document voor te bereiden.',
  only_pdf_and_images_are_supported: 'Alleen PDF en afbeeldingen worden ondersteund.',
  unlock_sms_verified_phone_number_field_with_paid_plan_use_text_field_for_phone_numbers_without_verification: 'Ontgrendel het SMS-geverifieerde veld voor telefoonnummer met een betaald abonnement. Gebruik het tekstveld voor telefoonnummers zonder verificatie.',
  available_only_in_pro: 'Alleen beschikbaar in Pro',
  failed_to_download_files: 'Bestanden downloaden mislukt',
  please_add_fields_for_the_submitter_name_or_remove_the_submitter_name_if_not_needed: 'Voeg velden toe voor de {submitter_name}. Of verwijder de {submitter_name} als deze niet nodig is.',
  draw_field: 'Teken het veld {field}',
  replace: 'Vervangen',
  uploading_: 'Bezig met uploaden...',
  add_document: 'Doc. toevoegen',
  none: 'Geen',
  ssn: 'SSN',
  ein: 'EIN',
  email: 'E-mail',
  url: 'URL',
  zip: 'Postcode',
  custom: 'Aangepast',
  numbers_only: 'Alleen cijfers',
  letters_only: 'Alleen letters',
  regexp_validation: 'Regex validatie',
  custom_validation: 'Aangepaste Validatie',
  length_validation: 'Lengte Validatie',
  number_range: 'Getalbereik',
  enter_pdf_password: 'Voer PDF-wachtwoord in',
  wrong_password: 'Onjuist wachtwoord',
  currency: 'Valuta',
  save_and_preview: 'Opslaan & bekijken',
  preferences: 'Voorkeuren',
  available_in_pro: 'Beschikbaar in Pro',
  some_fields_are_missing_in_the_formula: 'Sommige velden ontbreken in de formule.',
  learn_more: 'Meer informatie',
  and: 'en',
  or: 'of',
  start_a_quick_tour_to_learn_how_to_create_an_send_your_first_document: 'Start een korte rondleiding om te leren hoe u uw eerste document maakt en verzendt',
  start_tour: 'Rondleiding starten',
  or_add_from: 'Of toevoegen van',
  sync: 'Synchroniseren',
  syncing: 'Synchroniseren...',
  copy: 'Kopiëren',
  paste: 'Plakken',
  select_fields: 'Velden Selecteren',
  draw_fields: 'Velden Tekenen',
  align_left: 'Links uitlijnen',
  align_right: 'Rechts uitlijnen',
  align_top: 'Boven uitlijnen',
  align_bottom: 'Onder uitlijnen',
  fields_selected: '{count} Velden Geselecteerd',
  field_added: '{count} Veld Toegevoegd',
  fields_added: '{count} Velden Toegevoegd'
}

export { en, es, it, pt, fr, de, nl }
